import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { animateScroll as scroll } from 'react-scroll';
import { Row, Column, Button } from '../ui/Styles';
import { Container, Title } from './Styles';

const goBack = (lastPos = 0) => () => {
  console.log('last', lastPos);
  scroll.scrollTo(lastPos);
};

const Work = ({ item, lastPos, viewable }) => {
  return (
    <Container className="work-page" viewable={viewable}>
      <Title>Work</Title>
      <Row className="work-page-row">
        <Column className="work-page-col" w={[1, 1 / 2]}>
          {
            <img
              alt={item.title}
              src={`${process.env.PUBLIC_URL}/${item.image_url}`}
            />
          }
        </Column>
        <Column className="work-page-col" w={[1, 1 / 2]}>
          <h2>{item.title}</h2>
          <p>{item.description}</p>
          <Row>
            <Column>
              <h3>Coding Requirements</h3>
              <p>{item.code}</p>
            </Column>
          </Row>
          <Row>
            <Column w={[1 / 2]}>
              {item.url && (
                <ReactGA.OutboundLink
                  eventLabel="visitSiteLink"
                  target="_blank"
                  to={item.url}
                >
                  <Button>Visit site</Button>
                </ReactGA.OutboundLink>
              )}
            </Column>
            <Column w={[1 / 2]}>
              <Button onClick={goBack(lastPos)} right>
                Go Back
              </Button>
            </Column>
          </Row>
        </Column>
      </Row>
    </Container>
  );
};

Work.propTypes = {
  item: PropTypes.shape({ title: PropTypes.string.isRequired }),
  lastPos: PropTypes.number.isRequired,
  viewable: PropTypes.bool.isRequired
};

export default Work;



// WEBPACK FOOTER //
// ./src/components/WorkPage/index.js